




































































/** @format */

import { Vue, Component, Mixins, Watch } from 'vue-property-decorator';
import * as routeNames from '../router-names';

import moment from 'moment';
import { queryOrderEnterDetail } from '../../../api/order-management';
import { API_SERVER } from '@/common/config';

import ParkingReviewImage from '../../../components/parking-review-image/index.vue';
import GoBackWithCloseTab from '@/common/mixins/go-back-with-close-tab';
import ShowImg from '@/components/show-img/index.vue';
@Component({
  components: {
    ParkingReviewImage,
    ShowImg
  }
})
export default class EnterCarDetail extends Mixins(GoBackWithCloseTab) {
  navs = [
    {
      label: '在场车辆',
      location: {
        name: routeNames.ENTER_CAR_LIST
      }
    },
    {
      label: '在场车辆详情'
    }
  ];
  reviewColums = [
    {
      imageSrc: 'img',
      data: [
        {
          label: '入场时间',
          dataIndex: 'time'
        },
        {
          label: '入场通道',
          dataIndex: 'channelName'
        }
      ]
    }
  ];
  reviewModelDate = {};
  showReviewImgModel: boolean = false;
  private imgBaseUrl = `${API_SERVER.imgBaseUrl}`;
  private defaultImg = `${API_SERVER.defaultImg}`;
  pkOrderId = '';
  parkId = '';
  detailModel = {};
  parkingDetail = [
    {
      prop: 'parkingTime',
      label: '停车时长:',
      render(h: any, params: any) {
        const { parkingTime = '' } = params.data;
        return h(
          'a-tooltip',
          {
            attrs: {
              placement: 'topLeft',
              title: parkingTime
            }
          },
          [
            h(
              'div',
              {
                class: 'text-ellipse',
                attrs: {
                  style: 'width:120px'
                }
              },
              parkingTime || '-'
            )
          ]
        );
      }
    },
    {
      prop: 'dutyOfficer',
      label: '入场操作员:'
    },

    {
      prop: 'enterChannelName',
      label: '入场通道:'
    },
    {
      prop: 'pkOrderId',
      label: '停车订单号:',
      render(h: any, params: any) {
        const { pkOrderId = '' } = params.data;
        return h(
          'a-tooltip',
          {
            attrs: {
              placement: 'topLeft',
              title: pkOrderId
            }
          },
          [
            h(
              'div',
              {
                class: 'text-ellipse',
                attrs: {
                  style: 'width:140px'
                }
              },
              pkOrderId || '-'
            )
          ]
        );
      }
    }
    // {
    //   prop: 'enterEventName',
    //   label: '入场方式',
    // },
  ];

  infoFields = [
    {
      prop: 'enterTime',
      label: '进场时间:'
    },
    {
      prop: 'authTypeName',
      label: '车辆类型:'
    },
    {
      prop: 'authorizDate',
      label: '授权期限:'
    },
    {
      prop: 'userName',
      label: '姓名:'
    },
    {
      prop: 'userTel',
      label: '联系电话:'
    },
    {
      prop: 'carType',
      label: '车型:'
    }
    // {
    //   prop: 'remark',
    //   label: '备注',
    // },
  ];
  payRecordsTableColums = [
    {
      title: '缴费方式',
      dataIndex: 'payMethodName'
    },
    {
      title: '平台流水号',
      dataIndex: 'orderId'
    },
    {
      title: '第三方交易流水号',
      dataIndex: 'thirdTradeNo'
    },
    {
      title: '交易时间',
      dataIndex: 'paidTime'
    },
    {
      title: '交易金额',
      dataIndex: 'paidAmount',
      customRender: (text: any, record: any, index: number) =>
        Number(text || 0).toFixed(2) ? `${Number(text || 0).toFixed(2)}元` : '--'
    }
  ];
  tripRealRecordsTabColums = [
    {
      title: '区域',
      dataIndex: 'areaName'
    },
    {
      title: '通道',
      dataIndex: 'channelName'
    },
    {
      title: '进出场类型',
      dataIndex: 'typeName'
    },
    {
      title: '通行时间',
      dataIndex: 'time'
    },
    {
      title: '图片',
      dataIndex: 'img',
      scopedSlots: { customRender: 'img' }
    }
  ];
  async created() {
    console.log('created');
    if (!(this.$route.params && this.$route.params.from)) {
      console.log('走这里了么from');
      this.init();
      if (this.pkOrderId) {
        this.queryOrderEnter();
      }
    }
  }
  async activated() {
    this.init();
    if (this.pkOrderId) {
      this.queryOrderEnter();
    }
    console.log('activated');
  }
  private init() {
    this.pkOrderId = this.$route.params.pkOrderId as string;
    this.parkId = this.$route.params.parkId as string;
  }
  showImg(obj: any) {
    this.showReviewImgModel = true;
    this.reviewModelDate = obj;
  }
  /**
   * 获取数据
   */
  private async queryOrderEnter() {
    this.detailModel = {};
    try {
      const { status, msg, code, data = {} } = await queryOrderEnterDetail({
        pkOrderId: this.pkOrderId,
        parkId: this.parkId
      });
      if (status !== '9999') {
        this.$message.error(msg);
      }
      if (data) {
        this.detailModel = data;
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      console.log('queryOrderEnterDetail,出现错误', error);
    }
  }
  getEnterImg(index: any) {
    window.open((this.$refs.enterImg as any).src);
  }
}
